"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useCallback, useEffect } from "react";

import { Nav } from "@/components/nav";
import { Link } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import { useAppDispatch, useAppSelector } from "@/services/hooks/redux.hooks";
import useScreenSize from "@/services/hooks/screen.hooks";
import { toggleSidebar as action } from "@/services/redux/exchange-switcher.slice";

import { ExchangeSwitcher } from "./global/exchange-swticher";
import LogoIcon from "./global/LogoIcon";
import LogoText from "./global/LogoText";
import { PremiumCard } from "./premiumCard";
import { Button } from "./ui/button";

export default function Sidebar() {
  const { width } = useScreenSize();
  // const { startOnborda } = useOnborda();
  // const pathname = usePathname();
  const isCollapsed = useAppSelector(
    (state) => state.exchangeSwitcher.isSideBarCollapsed,
  );
  const dispatch = useAppDispatch();
  const { options } = useAppSelector((state) => state.sidebar);

  const toggleSidebar = useCallback(() => {
    dispatch(action(!isCollapsed));
  }, [dispatch, isCollapsed]);

  useEffect(() => {
    if (width <= 1080 && width > 1023) {
      dispatch(action(true));
    } else if (width <= 1023) {
      dispatch(action(false));
    }
  }, [width, dispatch]);

  return (
    <div
      className={cn(
        "hidden h-screen lg:flex flex-col fixed border-r pb-10 z-50 bg-sidebar",
        isCollapsed ? "" : "w-[250px]",
      )}
    >
      <div className="absolute -right-5 bottom-24">
        <Button
          onClick={toggleSidebar}
          variant="secondary"
          className="rounded-full p-2"
        >
          {!isCollapsed ? <ChevronLeft /> : <ChevronRight />}
        </Button>
      </div>
      <Link href="/dashboard">
        <div
          className={cn(
            "py-3 px-4 border-b",
            isCollapsed ? "flex items-center justify-center" : "",
          )}
        >
          {isCollapsed ? (
            <LogoIcon className="h-8 w-auto" />
          ) : (
            <LogoText className="h-8 w-auto" />
          )}
        </div>
      </Link>
      <div
        className={isCollapsed ? "flex items-center justify-center mt-4" : ""}
      >
        <>
          <div id="tour_exchangeselect">
            <ExchangeSwitcher />
          </div>
        </>
      </div>
      <Nav isCollapsed={isCollapsed} links={options} />

      {/* {["/dashboard", "/smart-allocation"].includes(pathname) ? (
        <Button
          className="rounded-none mt-4"
          size="sm"
          onClick={() => {
            const tour = pathname.includes("/smart-allocation")
              ? "smart_allocation"
              : pathname.replace("/", "");
            startOnborda(tour);
          }}
        >
          Start tour
        </Button>
      ) : (
        <></>
      )} */}

      <PremiumCard isCollapsed={!isCollapsed} />
    </div>
  );
}
